import Vue from 'vue'
import Router from "vue-router";
//import firebase from 'firebase';
import Userauth from '../auth/js/index'
import Body from '../components/body'
//import Auth from '../auth/auth'
import '../assets/css/misestilos.css'
import '../components/utils/vue-treeselect/src/style.less'
//import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// component

Vue.use(Router)

const routes = [
{ path: '', redirect: { name: 'default' }},

{ path: '/auth/login', component: () => import('@/auth/login') },
{ path: '/auth/restore_password/:token/:environment_code/:user_id', component: () => import('@/auth/LoginRestorePassword') },
{ path: '/auth/change_password/:email/:userid', component: () => import('@/auth/LoginChangePassword') },
{ path: '/auth/login_from_token/:token', component: () => import('@/auth/LoginFromToken') },
{ path: '/auth/register_step_one', component: () => import('@/auth/RegisterStep1') },
{ path: '/auth/register_step_two/:subdominio', component: () => import('@/auth/RegisterStep2') },
{ path: '/auth/register_step_three/:email', component: () => import('@/auth/RegisterStep3') },
{ path: '/auth/validate_email/:token/:subdominio/:email', component: () => import('@/auth/ValidateEmail') },

/*{ path: '/email',component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/email/Email')
    },
    {
      path: 'detail',
      component: () => import('@/components/email/EmailDetail')
    }
  ]
},
{ path: '/dashboard',
  component: Body,
  children: [
    {
      path: 'default',
      component: () => import('@/components/dashboard/Dashboard')
    },
    {
      path: 'agent',
      component: () => import('@/components/dashboard/DashboardAgent')
    },
    {
      path: 'billing',
      component: () => import('@/components/dashboard/DashboardBilling')
    },
    {
      path: 'collections',
      component: () => import('@/components/dashboard/DashboardEjemplo')
    }
  ]
},*/
{ path: '/case',
  component: Body,
  children: [
    {
      path: 'list',
      name: 'default',
      component: () => import('@/components/casos/Caso')
    },
    {
      path: 'management_results',
      component: () => import('@/components/casos/CasoResultados')
    },
    {
      path: 'forms_configuration',
      component: () => import('@/components/casos/FormsConfiguration')
    },
  ]
},
/*{ path: '/delivery_admin',
  component: Body,
  children: [
    {
      path: 'list',
      name: 'default',
      component: () => import('@/components/delivery_admin/DeliveryAdmin')
    },
    {
      path: 'list_old',
      component: () => import('@/components/casos/gestion_casos/Caso')
    },
    {
      path: 'mylist',
      component: () => import('@/components/casos/mis_casos/MisCasos')
    },
    {
      path: 'play/:Id',
      component: () => import('@/components/casos/mis_casos/Atencion')
    },
    {
      path: 'read/:Id',
      component: () => import('@/components/casos/mis_casos/CasoView')
    },
    {
      path: 'management_results',
      component: () => import('@/components/casos/gestion_casos/parametros/CasoResultados')
    },
    {
      path: 'forms_configuration',
      component: () => import('@/components/casos/gestion_casos/parametros/FormsConfiguration')
    },
  ]
},*/
{ path: '/report',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/reportes/Report')
    },
    {
      path: 'read/:Id',
      component: () => import('@/components/reportes/ReportView')
    },
    {
      path: 'config/:Id',
      component: () => import('@/components/reportes/ReportConfig')
    },
    {
      path: 'viewer',
      component: () => import('@/components/reportes/ReportViewer')
    },
  ]
},
{ path: '/company',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/empresas/Empresa')
    }
  ]
},
{ path: '/rate',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/tarifario/Rate')
    }
  ]
},
/*{ path: '/time',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/tiempos/Time')
    },
  ]
},

{ path: '/project',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/proyectos/Proyecto')
    },
    {
      path: 'play/:Id',
      component: () => import('@/components/proyectos/ProyectoAtencion')
    },
    {
      path: 'read/:Id',
      component: () => import('@/components/proyectos/ProyectoView')
    },
  ]
},

{ path: '/project_client',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/proyecto_clientes/ProyectoCliente')
    },
  ]
},

{ path: '/infra',
  component: Body,
  children: [
    {
      path: 'datacenter/list',
      component: () => import('@/components/infra/datacenter/InfraDatacenter')
    },
    {
      path: 'virtualizer_server/list',
      component: () => import('@/components/infra/servidor_virtualizador/InfraServidorVirtualizador')
    },
    {
      path: 'virtualizer_server/config/:Id',
      component: () => import('@/components/infra/servidor_virtualizador/InfraServidorVirtualizadorConfig')
    },
    {
      path: 'server/list',
      component: () => import('@/components/infra/servidor/InfraServidor')
    },
    {
      path: 'server/config/:Id',
      component: () => import('@/components/infra/servidor/InfraServidorConfig')
    },
    {
      path: 'virtual_env/list',
      component: () => import('@/components/infra/ambiente_virtual/InfraAmbienteVirtual')
    },
    {
      path: 'virtual_env/config/:Id',
      component: () => import('@/components/infra/ambiente_virtual/InfraAmbienteVirtualConfig')
    },
    {
      path: 'sw/list',
      component: () => import('@/components/infra/software/InfraSoftware')
    },
    {
      path: 'list',
      component: () => import('@/components/infra/Infraestructura')
    },
    {
      path: 'list_old',
      component: () => import('@/components/infra/Ambiente')
    },
    {
      path: 'config/:Id',
      component: () => import('@/components/infra/AmbienteConfig')
    },
    {
      path: 'server_states/list',
      component: () => import('@/components/infra/servidor/InfraServidorEstados')
    },
    {
      path: 'virtual_env_states/list',
      component: () => import('@/components/infra/ambiente_virtual/InfraAmbienteVirtualEstados')
    },
    {
      path: 'software_states/list',
      component: () => import('@/components/infra/software/InfraSoftwareEstados')
    },

  ]
},*/
{ path: '/invoice',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/facturas/Invoice')
    }
  ]
},

{ path: '/contact',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/contactos/Contact')
    }
  ]
},

{ path: '/service',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/productos/Product')
    }
  ]
},

{ path: '/settings',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/ajustes/Ajustes')
    }
  ]
},

{ path: '/google_drive',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/integraciones/googledrive/GoogleDrive')
    }
  ]
},

{ path: '/user',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/seguridad/usuarios/Usuario')
    },
    {
      path: 'ad',
      component: () => import('@/components/seguridad/usuarios/ActiveDirectory')
    },
    {
      path: 'sso',
      component: () => import('@/components/seguridad/usuarios/SingleSignOn')
    },
    {
      path: 'audit',
      component: () => import('@/components/seguridad/usuarios/Auditoria')
    },
  ]
},

{ path: '/rol',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/seguridad/roles/Rol')
    }
  ]
},

/*{ path: '/environment',
  component: Body,
  children: [
    {
      path: 'list',
      component: () => import('@/components/seguridad/environments/Environment')
    },
    {
      path: 'read/:Id',
      component: () => import('@/components/seguridad/environments/EnvironmentView')
    },
  ]
},*/

{ path: '/icons',
  component: Body,
  children: [
    {
      path: 'ico',
      component: () => import('@/components/icons/ico_icon')
    },
    {
      path: 'themify',
      component: () => import('@/components/icons/themify_icon')
    },
    {
      path: 'fontawesome',
      component: () => import('@/components/icons/font_awesome')
    },
    {
      path: 'feather_icon',
      component: () => import('@/components/icons/feather_icon')
    },
  ]
},

];


const router = new Router({
  routes,
  base: '/',
  mode: 'history',
  linkActiveClass: "active",
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

router.beforeEach((to, from, next) => {
  
  if(to.meta.title) {
    document.title = to.meta.title;
  }
  
  if (
    to.path.includes('/auth/login') || 
    to.path.includes('/auth/register_step_one') || 
    to.path.includes('/auth/register_step_two') || 
    to.path.includes('/auth/register_step_three') ||
    to.path.includes('/auth/validate_email') ||
    to.path.includes('/auth/restore_password') || 
    to.path.includes('/auth/login_from_token') || 
    to.path.includes('/auth/change_password') || 
    Userauth.isAuthenticatedFor(to.path)){
    return next();
  }
  next('/auth/login')
  
});


export default router
